/**
 * AD-042 go-live SAFETY (2026-06-25) — the no-login `/preview-intake` route was a
 * review-only tool for the isolated Firebase PREVIEW CHANNEL. Per the owner's
 * "no previews on the live domain" rule (memory `feedback_no_previews_on_live_in_domain`),
 * it must NOT be reachable on PRODUCTION hosting.
 *
 * Gate by HOSTNAME (the only reliable signal — production and a preview channel
 * are the SAME Firebase site built by the SAME `vite build`, so an env flag can't
 * distinguish them):
 *   - Firebase PREVIEW channels are always `<site>--<channel>-<hash>.web.app`
 *     (they contain `--`). ALLOW.
 *   - localhost / 127.0.0.1 (dev server). ALLOW.
 *   - everything else — the LIVE domains `portal.aayatanveda.in` and the bare
 *     `avbp-portal.web.app` (no `--`) — DENY (route renders NotFound).
 *
 * Pure: takes a hostname string so it is unit-testable without a DOM.
 */

/** PURE — is this hostname a dev / Firebase-preview-channel host (preview tool allowed)? */
export function isPreviewHost(hostname: string): boolean {
  const h = (hostname || '').toLowerCase();
  if (!h) return false;
  // Dev server.
  if (h === 'localhost' || h === '127.0.0.1' || h.startsWith('localhost:') || h === '0.0.0.0') return true;
  // Firebase preview channel: `<site>--<channel>-<hash>.web.app` (contains `--`).
  if (h.includes('--') && h.endsWith('.web.app')) return true;
  return false;
}

/** Read the live hostname (browser) and apply the gate. SSR/test-safe (no window → false). */
export function previewRouteAllowed(): boolean {
  if (typeof window === 'undefined' || !window.location) return false;
  return isPreviewHost(window.location.hostname);
}
